import React from 'react';

interface MyAncLogoProps {
    /** Height of the logo, in pixels. */
    size?: number;
}

/** The logo of the backoffice, cropped to its artwork so it stays readable at the height of a header. */
const MyAncLogo: React.FC<MyAncLogoProps> = ({ size = 48 }) => (
    <img src='/logo-header.png' alt='MyANC' style={{ display: 'block', height: size, width: 'auto', flexShrink: 0 }} />
);

export default MyAncLogo;
